import { Grid, Group, NumberFormatter, Text } from '@mantine/core';
import React, { Component } from 'react';
import { FiGift } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import Card from '../elements/Card';
import { TbCircleLetterP } from 'react-icons/tb';
import Badge from '../elements/Badge';
import './styles.scss';

interface CardMissionProps {
  item: any;
}

export default class CardMission extends Component<CardMissionProps> {
  render() {
    return (
      <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
        <Link
          to={`/mission/${this.props.item.missionID}`}
          style={{
            textDecoration: 'none',
            cursor: 'pointer'
          }}
        >
          <Card className="mission-item">
            <Badge
              color={
                this.props.item.missionCategory === 'Pick Mission'
                  ? 'green'
                  : 'gray'
              }
              variant="light"
            >
              {this.props.item.missionCategory}
            </Badge>
            <Group justify="space-between" mt="md" mb="xs">
              <Text fw={500}>{this.props.item.missionName}</Text>
            </Group>

            <Text size="sm" c="dimmed" mih={80}>
              {/* render dangerously */}

              <div
                dangerouslySetInnerHTML={{
                  __html:
                    this.props.item.missionDescription.length > 100
                      ? this.props.item.missionDescription.substring(0, 100) +
                        '...'
                      : this.props.item.missionDescription
                }}
              ></div>
            </Text>
            <Group justify="space-between">
              <Group gap={4}>
                <TbCircleLetterP size={20} color="orange" />
                <Text fw={800} size="sm">
                  <NumberFormatter
                    value={Number(this.props.item.rewardPoint)}
                    suffix={` Point${
                      Number(this.props.item.rewardPoint) > 1 ? 's' : ''
                    }`}
                    thousandSeparator="."
                    decimalSeparator=","
                  />
                </Text>
              </Group>
              <Group gap={4}>
                <FiGift size={20} />
                <Text fw={800} size="sm">
                  <NumberFormatter
                    value={Number(this.props.item.rewardXP)}
                    suffix={' XP'}
                    thousandSeparator="."
                    decimalSeparator=","
                  />
                </Text>
              </Group>
            </Group>
          </Card>
        </Link>
      </Grid.Col>
    );
  }
}
